"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightWithDrillDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var model_1 = require("../../../../model");
var drill_1 = require("../../../drill");
var types_1 = require("../../../../types");
var drillingUtils_1 = require("../../../../_staging/drills/drillingUtils");
var DashboardInsightWithDrillSelect_1 = require("./Insight/DashboardInsightWithDrillSelect");
var InsightDrillDialog_1 = require("./InsightDrillDialog/InsightDrillDialog");
/**
 * @internal
 */
exports.DashboardInsightWithDrillDialog = function (props) {
    var _a = tslib_1.__read(react_1.useState([]), 2), drillSteps = _a[0], setDrillSteps = _a[1];
    var activeDrillStep = last_1.default(drillSteps);
    var insight = activeDrillStep === null || activeDrillStep === void 0 ? void 0 : activeDrillStep.insight;
    var widget = props.widget;
    var breadcrumbs = react_1.useMemo(function () {
        return drillSteps
            .filter(function (s) { return types_1.isDrillDownDefinition(s.drillDefinition); })
            .map(function (s) { var _a; return (_a = drill_1.getDrillDownAttributeTitle(drillingUtils_1.getDrillOriginLocalIdentifier(s.drillDefinition), s.drillEvent)) !== null && _a !== void 0 ? _a : "NULL"; });
    }, [drillSteps]);
    var locale = model_1.useDashboardSelector(model_1.selectLocale);
    var setNextDrillStep = react_1.useCallback(function (drillStep) {
        setDrillSteps(function (s) { return tslib_1.__spread(s, [drillStep]); });
    }, []);
    var goBack = react_1.useCallback(function () { return setDrillSteps(function (_a) {
        var _b = tslib_1.__read(_a, 1), firstDrill = _b[0];
        return [firstDrill];
    }); }, []);
    var onClose = react_1.useCallback(function () { return setDrillSteps([]); }, []);
    var onDrillDown = react_1.useCallback(function (evt) { return setNextDrillStep(evt.payload); }, [setNextDrillStep]);
    var onDrillToInsight = react_1.useCallback(function (evt) { return setNextDrillStep(evt.payload); }, [setNextDrillStep]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DashboardInsightWithDrillSelect_1.DashboardInsightWithDrillSelect, tslib_1.__assign({}, props, { onDrillDown: onDrillDown, onDrillToInsight: onDrillToInsight })),
        activeDrillStep ? (react_1.default.createElement(InsightDrillDialog_1.InsightDrillDialog, { locale: locale, breadcrumbs: breadcrumbs, widget: widget, insight: insight, onDrillDown: onDrillDown, onBackButtonClick: goBack, onClose: onClose })) : null));
};
//# sourceMappingURL=DashboardInsightWithDrillDialog.js.map